module.exports = __webpack_public_path__ + "assets/img/Clipboard3@2x.b3e04980.jpg";